import { createAction } from 'redux-actions'
import * as types from '@src/store/types'

export const setErrorMessage = createAction(types.SET_ERROR_MESSAGE)
export const clearErrorMessage = createAction(types.CLEAR_ERROR_MESSAGE)
export const clearInputErrorMessage = createAction(types.CLEAR_INPUT_ERROR_MESSAGE)

export const handleErrorMessagesDone = createAction(types.HANDLE_ERROR_MESSAGES_DONE)
export const handleErrorMessagesFail = createAction(types.HANDLE_ERROR_MESSAGES_FAIL)